(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layout-footer"]) return;
  try {
    
  // Launch when user clicks dropdown canada selector
  document.addEventListener("DOMContentLoaded", function(event) {
    
    function currencyFormSubmit(event) {
      fetch('/cart/clear.js').then(function(response) {
        console.log('clear');
      });
      event.target.form.submit();
    }

    document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
      element.addEventListener('change', currencyFormSubmit);      
    });

    setTimeout(() => {
      const cookie_obj = document.getElementById("popup_messages-cookie_name");
      if (cookie_obj) {
        const cookie_name = cookie_obj.value;

        let cookie = getCookie(cookie_name);
        if(!cookie){
          const popupObj = document.getElementById("popup_messages");
          if (popupObj) {
            popupObj.classList.remove("closed"); 
            popupObj.classList.add("opened");
          }
        }
      }
 
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-header"]) return;
  try {
    
	const collapseMenuNav = (linkElem) => {
		const collapsibleLink = linkElem.nextElementSibling;

		if (collapsibleLink.classList.contains("invisible")) {
			linkElem.children[1].children[0].classList.replace("ico-chevron-down", "ico-chevron-up");
			collapsibleLink.classList.add("bg-white");
		} else {
			linkElem.children[1].children[0].classList.replace("ico-chevron-up", "ico-chevron-down");
			collapsibleLink.classList.remove("bg-white");
		}
		collapsibleLink.classList.toggle("max-h-0");
		collapsibleLink.classList.toggle("invisible");
	}
	window.collapseMenuNav = collapseMenuNav;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  var er_script = document.createElement('script');
  er_script.setAttribute('id','esc-redirects-404-script');
  er_script.setAttribute('src','https://easyredirects.esc-apps-cdn.com/app.js');
  document.head.appendChild(er_script);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart2"]) return;
  try {
    
  window.addEventListener("load", function(event) {
    const split_payments_amount = document.getElementById("split_payments_amount").innerText;
    const split_payments_text = document.getElementById("split_payments_text");
    split_payments_text.innerHTML = split_payments_text.innerHTML.replace("split_payments_amount", split_payments_amount);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const scrollToReview = () => {
    const stampedComponent = document.getElementById("stamped-main-widget");
    stampedComponent?.scrollIntoView();
  }
  window.scrollToReview = scrollToReview;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-messages"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event) {    
    const popup_enabled = () => {
      const elem = document.getElementById("popup_messages-popup_enabled");
      return (elem && elem.value == "true") ? true : false;
    };
    console.log('popup enabled: ' + popup_enabled());

    if (popup_enabled()) {
      const launch_automatic = () => {
        const elem = document.getElementById("popup_messages-launch_automatic");
        return (elem && elem.value == "true") ? true : false;
      };
      const cookie_name = document.getElementById("popup_messages-cookie_name").value;

      const popupObj = document.getElementById("popup_messages");
      const popup_always = popupObj.classList.contains("popup_always");
      
      if (launch_automatic() && (popup_always || getCookie(cookie_name) === undefined)) {
        popupObj.classList.remove("closed");
        popupObj.classList.add("opened");
      }

      const closePopup = (ommited = false, setLang = Shopify.locale) => {
        popupObj.classList.remove("opened");
        popupObj.classList.add("closed");
        if (!popup_always && !ommited) {
          setCookie(cookie_name, setLang, 30);
        }
      }
      window.closePopup = closePopup;

      const popupSwitchLanguage = (lang = "/") => {      
        const currLangPath = (Shopify.locale === "en") ? "" : Shopify.locale;
        const desiredLangCode = lang.replaceAll('/', '');
        closePopup(false, desiredLangCode ? desiredLangCode : 'en');
        if(currLangPath !== desiredLangCode) {
          const newPath = window.location.pathname.replace(`/${Shopify.locale}/`,'');
          window.location.href = `/${desiredLangCode}${newPath}`;
        }
      }
      window.popupSwitchLanguage = popupSwitchLanguage;

      const popupRedirect = (route = "/") => {
        closePopup(false);
        window.location.href = route;
      }
      window.popupRedirect = popupRedirect;
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-page-klaviyo"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event) {
    var _learnq = _learnq || [];
    _learnq.push(['identify', {
      '$email' : document.getElementById("klaviyo_customer_email").value
    }]);
    _learnq.push(['account', document.getElementById("klaviyo_company_id").value]);
    
    /*(function () {
      var b = document.createElement('script');
      b.type = 'text/javascript';
      b.async = true;
      b.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'a.klaviyo.com/media/js/analytics/analytics.js';
      var a = document.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(b, a);
    })();*/
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-page-multicolumn-pro"] && !window.DesignMode) return;
  try {
    
  // This block is executed only ONCE along the page, even if you have multiple sections added.

  document.addEventListener("DOMContentLoaded", function(event) {
    if (window.location.pathname.split('/')[1].toLowerCase() === "fr") {
      const englishImages = document.querySelectorAll(".page-multicolumn-pro .images_selector .img_english");
      englishImages.forEach(image => {
        image.className = "hidden"; // Hides everything
      });
    } else {
      const frenchImages = document.querySelectorAll(".page-multicolumn-pro .images_selector .img_french");
      frenchImages.forEach(image => {
        image.className = "hidden"; // Hides everything
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-tree-counter"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event) {
    if (Shopify.locale.toLowerCase() === "fr") {
      const frenchImages = document.querySelectorAll(".tree-counter-circle .img_french");
      frenchImages.forEach(image => {
        image.classList.remove("img_hide");
        image.classList.add("img_show");
      });
      
      const englishImages = document.querySelectorAll(".tree-counter-circle .img_english");
      englishImages.forEach(image => {
        image.classList.remove("img_show");
        image.classList.add("img_hide");
      });
    } else {
      const frenchImages = document.querySelectorAll(".tree-counter-circle .img_french");
      frenchImages.forEach(image => {
        image.classList.remove("img_show");
        image.classList.add("img_hide");
      });
      
      const englishImages = document.querySelectorAll(".tree-counter-circle .img_english");
      englishImages.forEach(image => {
        image.classList.remove("img_hide");
        image.classList.add("img_show");
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
